import { faImage } from '@fortawesome/pro-regular-svg-icons'
import { faGripVertical, faThumbtack } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Paper, Theme, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import cn from 'classnames'

import { ContentItem } from '../../ContentManagementProvider/Context'
import { FeaturedPill } from '../ContentManagementTable/ContentTable/ContentTableRow'

const useStyles = makeStyles<Theme, { isSortable: boolean }>((theme) => ({
  dndContainer: {
    height: '100%',
    maxHeight: '100%',
    minHeight: '100%',
    padding: 0,
  },
  image: {
    minWidth: 50,
    height: 50,
    borderRadius: 8,
  },
  noOverflow: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 1,
  },
  emptyImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.text.disabled,
  },
  emptyImageIcon: {
    height: theme.spacing(3),
    width: theme.spacing(3),
  },
  reorderItemContainer: {
    display: 'flex',
    flexGrow: 1,
    overflow: 'hidden',
    padding: theme.spacing(1, 2),
    gap: theme.spacing(2),
    '&:hover': {
      backgroundColor: ({ isSortable }) => (isSortable ? 'rgba(0, 125, 170, 0.08)' : theme.palette.common.white),
    },
  },
}))

export const ReorderListItem = ({
  contentItem,
  isSortable = true,
}: {
  contentItem: ContentItem
  isSortable?: boolean
}) => {
  const classes = useStyles({ isSortable })
  const stripDescription = () => {
    const desc = new DOMParser().parseFromString(contentItem.description, 'text/html')
    return desc.body.textContent || ''
  }
  return (
    <Paper className={classes.reorderItemContainer}>
      {contentItem.image.length ? (
        <img
          className={classes.image}
          src={contentItem.image}
          alt={contentItem.title}
        />
      ) : (
        <Box className={cn(classes.image, classes.emptyImage)}>
          <FontAwesomeIcon
            icon={faImage}
            className={classes.emptyImageIcon}
          />
        </Box>
      )}
      <Box
        display="flex"
        flexDirection="column"
        flex={1}
      >
        <Typography
          color="textPrimary"
          className={classes.noOverflow}
        >
          {contentItem.title}
        </Typography>
        <Typography
          color="textSecondary"
          variant="body2"
          className={classes.noOverflow}
        >
          {stripDescription()}
        </Typography>
      </Box>
      {contentItem.isFeatured && (
        <Box
          display="flex"
          alignItems={'center'}
        >
          <FeaturedPill>
            <FontAwesomeIcon icon={faThumbtack} />
            Featured
          </FeaturedPill>
        </Box>
      )}
      {isSortable && (
        <Box
          display="flex"
          alignItems="center"
          color="text.disabled"
        >
          <FontAwesomeIcon
            icon={faGripVertical}
            size="lg"
          />
        </Box>
      )}
    </Paper>
  )
}
